module.exports = __webpack_public_path__ + "static/media/au-ac.7e0a61ab.svg";